import { AssessmentReportInfo } from '../../../../models/assessmentReportInfo';
export class ReviewReportsPageController {
    /*@ngInject*/
    constructor($rootScope, $uibModal, $timeout, DTOptionsBuilder, DTColumnDefBuilder, $filter, StorageService, candidateService, companyService, dateTimeUtilityService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.DTOptionsBuilder = DTOptionsBuilder,
            this.DTColumnDefBuilder = DTColumnDefBuilder;
        this.$filter = $filter;
        this.StorageService = StorageService;
        this.candidateService = candidateService;
        this.companyService = companyService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        this.userRole = this.$rootScope.userDetails.roleScreenRef.role.name;
        this.isAuthorizedToAddAndEdit = true;
        this.assessmentReports = [];
        this.companyType = this.$rootScope.userDetails.company.companyType;
        this.actionType = "";
        this.loading = true;
        this._setFilters();
        this.initializeStartAndEndDates();
        this.getAllCandidatesReportDetails();
        this.initTableData();
    }
    _setFilters() {
        this.filterObject = {
            companyId: this.$rootScope.userDetails.company.companyId,
            searchText: '',
            startDate: this.dateTimeUtilityService.getDateTimeInAPIFormat(moment(new Date()).add(-3, 'M').toDate()),
            endDate: this.dateTimeUtilityService.getDateTimeInAPIFormat(moment(new Date()).add(1, 'd').toDate()),
            isVendorCandidates: false,
            page: '1',
            size: '50000',
            column: null,
            sortDir: 'ASC'
        };
        var previouslySelectedCandidatesTypeVendor = this.StorageService.get('reviewReportsCandidatesTypeVendor');
        if (!_.isNull(previouslySelectedCandidatesTypeVendor) && previouslySelectedCandidatesTypeVendor !== undefined && this.companyType == 'Corporation') {
            this.filterObject.isVendorCandidates = previouslySelectedCandidatesTypeVendor;
        }
        else {
            this.filterObject.isVendorCandidates = false;
        }
        this.StorageService.set('reviewReportsCandidatesTypeVendor', this.filterObject.isVendorCandidates);
    }
    initializeStartAndEndDates() {
        $(document).ready(() => {
            var currentDate = new Date();
            var startDate = moment(currentDate).add(-3, 'M').toDate();
            var momentOfDefaultEndDateTime = moment(currentDate);
            $('#startDate').datepicker({
                format: "M d, yyyy",
                weekStart: 1,
                autoclose: true
            });
            $("#startDate").datepicker("setDate", startDate);
            $("#startDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(startDate));
            $('#endDate').datepicker({
                format: "M d, yyyy",
                startDate: startDate,
                weekStart: 1,
                autoclose: true
            });
            $("#endDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            $("#endDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            this.filterObject.startDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.filterObject.startDateDisplayValue));
            this.filterObject.endDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.filterObject.endDateDisplayValue).setHours(23, 59, 59, 999));
            $('#startDate').datepicker().on('changeDate', (e) => {
                this.filterObject.startDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.filterObject.startDateDisplayValue));
                this.filterObject.endDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.filterObject.endDateDisplayValue).setHours(23, 59, 59, 999));
                this.getAllCandidatesReportDetails();
            });
            $('#endDate').datepicker().on('changeDate', (e) => {
                this.filterObject.startDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.filterObject.startDateDisplayValue));
                this.filterObject.endDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.filterObject.endDateDisplayValue).setHours(23, 59, 59, 999));
                this.getAllCandidatesReportDetails();
            });
        });
    }
    getAllCandidatesReportDetails() {
        this.loading = true;
        if (this.dtInstance && this.dtInstance.DataTable) {
            this.dtInstance.DataTable.destroy();
        }
        this.companyService.getAllCandidatesReportDetails(this.filterObject, (data) => {
            this.assessmentReports = this._massageReportsData(data);
            this.$timeout(() => {
                this.loading = false;
            }, 200);
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _massageReportsData(reports) {
        angular.forEach(reports, (report, index) => {
            report.reportGeneratedDateUTC = moment(report.reportGeneratedDateTime).tz("UTC").format("MMM D, YYYY");
            report.reportGeneratedTimeUTC = moment(report.reportGeneratedDateTime).tz("UTC").format("h:mm a");
            report.appearedOnDateUTC = moment(report.appearedOn).tz("UTC").format("MMM D, YYYY");
            report.appearedOnTimeUTC = moment(report.appearedOn).tz("UTC").format("h:mm a");
            report.violationType = "";
            if (report.assessmentReportInfoList.length > 0) {
                report.violationType = report.assessmentReportInfoList[report.assessmentReportInfoList.length - 1].type;
            }
        });
        return reports;
    }
    initTableData() {
        this.dtInstance = {};
        let backGroundEmptyLabel = 'No Reports Available';
        this.dtOptions = this.DTOptionsBuilder.newOptions()
            .withPaginationType('full_numbers')
            .withOption('order', [1, 'desc'])
            .withOption('bFilter', true)
            .withOption('bLengthChange', false)
            .withOption('bInfo', true)
            .withOption('searching', true)
            .withOption('language', { search: "", searchPlaceholder: 'Search', zeroRecords: backGroundEmptyLabel })
            .withBootstrap();
        this.dtColumns = [
            this.DTColumnDefBuilder.newColumnDef(0),
            this.DTColumnDefBuilder.newColumnDef(1),
            this.DTColumnDefBuilder.newColumnDef(2).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(3).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(4).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(5).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(6).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(7).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(8).notSortable(),
            this.DTColumnDefBuilder.newColumnDef(9).notSortable() //comments
        ];
    }
    onCandidatesTypeChanged() {
        this.StorageService.set('reviewReportsCandidatesTypeVendor', this.filterObject.isVendorCandidates);
        this.getAllCandidatesReportDetails();
    }
    editComment(report) {
        this.actionType = "edit";
        this.launchActionsModal(report);
    }
    deleteComment(report) {
        this.actionType = "delete";
        this.launchActionsModal(report);
    }
    launchActionsModal(report) {
        var actionType = this.actionType;
        var actionLabel = "";
        if (actionType == "edit") {
            actionLabel = "Edit comment";
            if (report.assessmentReportInfoList.length == 0) {
                report.assessmentReportInfoList.push(new AssessmentReportInfo());
            }
        }
        else if (actionType == "delete") {
            actionLabel = "Delete comment";
        }
        else {
            actionLabel = "View Report";
        }
        this.actionsModal = this.$uibModal.open({
            animation: false,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            windowClass: 'four-dot-five-modal-medium',
            component: 'reviewReportsActionsModal',
            backdrop: 'static',
            resolve: {
                actionType: () => {
                    return actionType;
                },
                actionLabel: () => {
                    return actionLabel;
                },
                assessmentInfo: () => {
                    return report;
                }
            }
        });
        this.actionsModal.result.then((callbackObject) => {
            if (callbackObject.callbackType == 'refresh') {
                this.getAllCandidatesReportDetails();
            }
        }, dismiss => {
            //do nothing;
        });
    }
    showDeleteConfirmationPopUp(report) {
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
            message: "Deleting the comment(s) (and any violation) entered.Are you sure to continue?",
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this._deleteComment(report);
                }
            }
        });
    }
    _deleteComment(report) {
        var commentId = null;
        this.candidateService.deleteCommentFromCandidateReportDetails(report.candidateAssessmentDetailId, commentId, (data) => {
            this.getAllCandidatesReportDetails();
            this.alertsAndNotificationsService.showBannerMessage('The comment(s) (and any violation) entered deleted successfully', 'success');
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    showReport(report) {
        this.actionType = "showReport";
        this.launchActionsModal(report);
    }
}
ReviewReportsPageController.$inject = ['$rootScope', '$uibModal', '$timeout', 'DTOptionsBuilder', 'DTColumnDefBuilder', '$filter', 'StorageService', 'candidateService', 'companyService', 'dateTimeUtilityService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './review-reports-page.html';
import * as TEMPLATE from 'raw-loader!./review-reports-page.html';
export const ReviewReportsPageComponent = {
    selector: 'reviewReportsPage',
    component: {
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/reports/reviewReports/review-reports-page.html',
        controller: ReviewReportsPageController
    }
};
//# sourceMappingURL=review-reports-page.component.js.map